// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"487":"receiving","554":"debtors","970":"payments"}[chunkId] + "." + {"487":"008e0235","554":"ff93560d","970":"f4c10c74"}[chunkId] + ".css";
};